export function resolveGuiVersionLabel(): string {
  const candidates = [
    process.env.NEXT_PUBLIC_GUI_VERSION_LABEL,
    process.env.NEXT_PUBLIC_GUI_VERSION,
  ];

  for (const candidate of candidates) {
    if (typeof candidate != "string") continue;
    const normalized = candidate.trim();
    if (normalized.length > 0) return normalized;
  }

  return "2";
}
